import { Room } from 'outpost';
import { Player } from '../player.ts';
import { MANA_SYMBOL } from '../constants.ts';
import { FloatingText } from '../animations/floating-text.ts';

export function onPlayerGainMana(player: Player, amount: number) {
    Room.update(player, () => player.mana += amount)
        .flash(new FloatingText(player.manaLabel, `+${amount}${MANA_SYMBOL}`));
}